import {CostItemAppAction} from "./reducer"
import {connect} from "react-redux"
import {StandardCostItems, CallbackProps, DataProps} from "./presentation"
import {ChangeActions} from "./reducer"
import {PricingOptionState} from "../common/types"
import {curriedCompose} from "../../../lib/utils"
import {StoreProps} from "../field-items/container";

const mapDispatchToStandardItemProps = (dispatch: (a: CostItemAppAction) => CostItemAppAction): CallbackProps => {
	const actionCreatorToCallback = curriedCompose(dispatch)
	return {
		onPriceChange: actionCreatorToCallback(ChangeActions.price),
		onPriceFieldChange: actionCreatorToCallback(ChangeActions.priceField),
		onModeChangeToPrice: actionCreatorToCallback(ChangeActions.modeToPrice),
		onModeChangeToInfoformField: actionCreatorToCallback(ChangeActions.modeToInfoformField),
		onGstStatusChange: actionCreatorToCallback(ChangeActions.gstStatus),
		onItemCodeChange: actionCreatorToCallback(ChangeActions.itemCode),
		onJobCodeChange: actionCreatorToCallback(ChangeActions.jobCode),
		onAccountNumberChange: actionCreatorToCallback(ChangeActions.accountNumber),
		onProrataPeriodChange: actionCreatorToCallback(ChangeActions.prorataPeriod),
	}
}

const mapStateToStandardItemProps = (store: PricingOptionState, ownProps: StoreProps): DataProps => {
	return {
		CostItems:          store.standardCostItems.items,
		SignupFields:       store.standardCostItems.signupFields,
		RenewFields:        store.standardCostItems.renewFields,
		AutoRenewalEnabled: store.standardCostItems.autoRenewalEnabled,
		FinancialCodeLabels: ownProps.labels
	}
}

export const StandardItemsContainer = connect<DataProps, CallbackProps, StoreProps, PricingOptionState>(
	mapStateToStandardItemProps,
	mapDispatchToStandardItemProps
)(StandardCostItems)




// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/standard-items/container.ts